if (!customElements.get('how-it-works')) {
  class HowItWorks extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.steps.length < 2 || this.reducedMotion) {
        this.steps.forEach(function (step) {
          step.setAttribute('data-active', '');
        });

        return;
      }

      const element = this;

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              element.activate(entry.target);
            }
          });
        },
        { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
      );

      this.steps.forEach(function (step) {
        element.observer.observe(step);
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    activate(target) {
      this.steps.forEach(function (step) {
        if (step === target) {
          step.setAttribute('data-active', '');
        } else {
          step.removeAttribute('data-active');
        }
      });
    }
  }

  customElements.define('how-it-works', HowItWorks);
}
